export default __webpack_public_path__ + "static/media/agilemind.0cea1744.png";